"use client";

import { createTheme } from "@mui/material";
import {
  BROADSHEET_MODE_ATTR,
  broadsheetCssVars,
  broadsheetDark,
} from "@/src/themes/broadsheet";
import {
  FONT_TEXT,
  STICKY_TOP,
} from "@/src/components/common/broadsheet/tokens";
import SelectCaret from "@/src/components/common/broadsheet/select-caret";

const darkTheme = createTheme({
  spacing: (factor: number) => `${factor}rem`,
  shape: {
    borderRadius: 0,
  },
  palette: {
    mode: "dark",
    background: {
      default: "#353434",
      paper: "#464444",
    },
    text: {
      primary: "#bababa",
      secondary: "#b2b2b2",
    },
    primary: {
      main: "#abd1c6",
    },
    secondary: {
      main: "#d3b976",
    },
    success: {
      main: "#4ae08a",
    },
    warning: {
      main: "#dcb95c",
    },
    error: {
      main: "#c9664b",
    },
    info: {
      main: "#bcd9dd",
    },
    divider: "#001e1d",
    common: {
      black: "#ffffff",
      white: "#000000",
    },
    custom: {
      ...broadsheetDark,
    },
  },
  typography: {
    fontFamily: FONT_TEXT,
    fontSize: 14,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ...broadsheetCssVars(
          broadsheetDark,
          `:root[${BROADSHEET_MODE_ATTR}="dark"]`,
        ),
        [`:root[${BROADSHEET_MODE_ATTR}="dark"] body`]: {
          colorScheme: "dark",
          backgroundColor: broadsheetDark.newsprint,
          color: broadsheetDark.ink,
        },
        [`:root[${BROADSHEET_MODE_ATTR}="dark"] [style*="--bf-cms-ink"]`]: {
          color: "var(--bf-cms-ink) !important",
        },
        html: {
          WebkitTapHighlightColor: "transparent",
        },
        "::selection": {
          backgroundColor: "var(--bf-rule)",
          color: "var(--bf-ink)",
        },
        ":focus-visible": {
          outline: "2px solid var(--bf-spine-teal)",
          outlineOffset: "2px",
        },
        "[id]": {
          scrollMarginTop: STICKY_TOP,
        },
        ".MuiPickersOutlinedInput-root.MuiPickersOutlinedInput-root, .MuiPickersOutlinedInput-notchedOutline.MuiPickersOutlinedInput-notchedOutline":
          {
            borderRadius: 0,
          },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: { borderRadius: 0 },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 0 },
        notchedOutline: { borderRadius: 0 },
      },
    },
    MuiAutocomplete: {
      defaultProps: {
        popupIcon: <SelectCaret />,
      },
    },
    MuiSelect: {
      defaultProps: {
        IconComponent: SelectCaret,
      },
      styleOverrides: {
        select: { borderRadius: 0 },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          verticalAlign: "middle",
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: "underline",
          "&:has(button)": {
            textDecoration: "none",
          },
        },
      },
    },
  },
});

export default darkTheme;
